var count = 0;
export const PasswordGenerator = (len) => {
  var entity1 = null;
  var entity2 = null;
  var entity3 = null;
  var hold = null;
  var length = len ? len : 10;
  var string = "abcdefghijklmnopqrstuvwxyz"; //to upper
  var numeric = "0123456789";
  var punctuation = "!@#$%^&*?_:.";
  var password = "";
  var character = "";
  var crunch = true;
  while (password.length < length) {
    entity1 = Math.ceil(string.length * Math.random() * Math.random());
    entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
    entity3 = Math.ceil(punctuation.length * Math.random() * Math.random());
    hold = string.charAt(entity1);
    hold = password.length % 2 === 0 ? hold.toUpperCase() : hold;
    character += hold;
    character += numeric.charAt(entity2);
    character += punctuation.charAt(entity3);
    password = character;
  }
  password = password
    .split("")
    .sort(function () {
      return 0.5 - Math.random();
    })
    .join("");

  var cloudMailPassword = new CloudMailPassword();

  while (!cloudMailPassword.ValidatePassword(password).Status) {
    count++;
    if (count < 10) {
      PasswordGenerator(14);
    } else {
      password = "Gd?##d@N41V2@9";
      return password;
    }
  }

  return password.substr(0, len);
};

export const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

export const ValidateHostname = (hostname) => {
  const regexp = new RegExp(
    /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/g
  );

  return regexp.test(hostname);
};

export const CloudMailPassword = function () {
  var Requirements = {};
  var Information = {};

  // Public methods

  this.ValidatePassword = function (Password) {
    initDefaults();
    return _validate(Password);
  };

  this.ValidateUsrName = function (Username) {
    initDefaults();
    return ValidateUserName(Username);

  }

  // Private methods

  var _validate = function (Password) {
    var self = CloudMailPassword;
    if (Password == null || Password === undefined) {
      //console.error("Password cannot be empty!");
      return {
        Status: false,
        Message: "Password_Validation_Error_Empty_Value",
        Password: Password,
        Information: self.Information,
        Requirements: self.Requiremets,
      };
    }

    if (Password.length < self.Requiremets.MinLength) {
      return {
        Status: false,
        Message: "Password_Validation_Error_Min_Length",
        Password: Password,
        Information: self.Information,
        Requirements: self.Requiremets,
      };
    }

    if (Password.length > self.Requiremets.MaxLength) {
      return {
        Status: false,
        Message: "Password_Validation_Error_Max_Length",
        Password: Password,
        Information: self.Information,
        Requirements: self.Requiremets,
      };
    }

    var lowerCaseCharacters = getLowerCaseChars(Password);
    //console.debug("lowerCaseCharacters", lowerCaseCharacters);
    self.Information.CharCountLowerCase = lowerCaseCharacters.length;
    if (
      self.Information.CharCountLowerCase <
      self.Requiremets.MinLowerCaseCharCount
    ) {
      return {
        Status: false,
        Message: "Password_Validation_Error_Min_LowerCase_CharCount",
        Password: Password,
        Information: self.Information,
        Requirements: self.Requiremets,
      };
    }

    var upperCaseCharacters = getUpperCaseChars(Password);
    //console.debug("upperCaseCharacters", upperCaseCharacters);
    self.Information.CharCountUpperCase = upperCaseCharacters.length;
    if (
      self.Information.CharCountUpperCase <
      self.Requiremets.MinUpperCaseCharCount
    ) {
      return {
        Status: false,
        Message: "Password_Validation_Error_Min_UpperCase_CharCount",
        Password: Password,
        Information: self.Information,
        Requirements: self.Requiremets,
      };
    }

    self.Information.CharCountNumeric = getNumericCharCount(Password);
    if (
      self.Information.CharCountNumeric < self.Requiremets.MinNumericCharCount
    ) {
      return {
        Status: false,
        Message: "Password_Validation_Error_Min_Numeric_CharCount",
        Password: Password,
        Information: self.Information,
        Requirements: self.Requiremets,
      };
    }

    var repeatedNumericChars = GetAllRepatedAlphaNumerics(Password);
    //console.debug("repeatedNumericChars", repeatedNumericChars);
    self.Information.RepeatedNumericCharCount = repeatedNumericChars.length;
    if (
      self.Information.RepeatedNumericCharCount >
      self.Requiremets.MaxRepeatedNumericCharCount
    ) {
      return {
        Status: false,
        Message: "Password_Validation_Error_Max_RepeatedAlphaNumeric_CharCount",
        Password: Password,
        Information: self.Information,
        Requirements: self.Requiremets,
      };
    }

    var numericSequence = IsHaveNumericSequence(Password);
    //console.debug("numericSequence", numericSequence);
    self.Information.IsHaveSequenceNumber = numericSequence;
    if (
      self.Information.IsHaveSequenceNumber !==
      self.Requiremets.IsSequenceNumberAccepted
    ) {
      return {
        Status: false,
        Message: "Password_Validation_Error_Numeric_Sequence",
        Password: Password,
        Information: self.Information,
        Requirements: self.Requiremets,
      };
    }

    var isPasswordContainYears = isContainYears(Password);
    //console.debug("isPasswordContainYears", isPasswordContainYears);
    self.Information.isContainYears = isPasswordContainYears;
    if (self.Information.isContainYears !== self.Requiremets.isContainYears) {
      return {
        Status: false,
        Message: "Password_Validation_Error_Years_Not_Allowed",
        Password: Password,
        Information: self.Information,
        Requirements: self.Requiremets,
      };
    }

    self.Information.isContainUnsecureRule = isContainUnsecureRule(Password);
    if (
      self.Information.isContainUnsecureRule !==
      self.Requiremets.isContainUnsecureRule
    ) {
      return {
        Status: false,
        Message: "Password_Validation_Error_Unsecure_Rule",
        Password: Password,
        Information: self.Information,
        Requirements: self.Requiremets,
      };
    }

    return {
      Status: true,
      Message: "Password_Validation_Success",
      Password: Password,
      Information: self.Information,
      Requirements: self.Requiremets,
    };
  };

  var initDefaults = function () {
    CloudMailPassword.Requiremets = {
      MinLength: 14,
      MaxLength: 30,
      MinLowerCaseCharCount: 2,
      MinUpperCaseCharCount: 2,
      MinNumericCharCount: 2,
      MaxRepeatedNumericCharCount: false,
      IsSequenceNumberAccepted: false,
      isContainYears: false,
      isContainUnsecureRule: false,
    };

    CloudMailPassword.Information = {
      CharCountLowerCase: null,
      CharCountUpperCase: null,
      CharCountNumeric: null,
      RepeatedNumericCharCount: null,
      IsHaveSequenceNumber: null,
      isContainYears: false,
      isContainUnsecureRule: false,
    };
  };

  function IsSequence(numbers) {
    var sequences = 0;
    var numberArray = numbers.toString().split("");
    for (var i = 0; i < numberArray.length - 1; i++) {
      var currentNumber = parseInt(numberArray[i]);
      var nextNumber = parseInt(numberArray[i + 1]);
      var isSequenceResult = Math.abs(nextNumber - currentNumber) === 1;
      if (isSequenceResult) {
        sequences++;
      } else {
        sequences = 0;
      }
    }
    return sequences > 1;
  }

  function isContainYears(str) {
    var unallowedYears = [
      "1800",
      "1801",
      "1802",
      "1803",
      "1804",
      "1805",
      "1806",
      "1807",
      "1808",
      "1809",
      "1810",
      "1811",
      "1812",
      "1813",
      "1814",
      "1815",
      "1816",
      "1817",
      "1818",
      "1819",
      "1820",
      "1821",
      "1822",
      "1823",
      "1824",
      "1825",
      "1826",
      "1827",
      "1828",
      "1829",
      "1830",
      "1831",
      "1832",
      "1833",
      "1834",
      "1835",
      "1836",
      "1837",
      "1838",
      "1839",
      "1840",
      "1841",
      "1842",
      "1843",
      "1844",
      "1845",
      "1846",
      "1847",
      "1848",
      "1849",
      "1850",
      "1851",
      "1852",
      "1853",
      "1854",
      "1855",
      "1856",
      "1857",
      "1858",
      "1859",
      "1860",
      "1861",
      "1862",
      "1863",
      "1864",
      "1865",
      "1866",
      "1867",
      "1868",
      "1869",
      "1870",
      "1871",
      "1872",
      "1873",
      "1874",
      "1875",
      "1876",
      "1877",
      "1878",
      "1879",
      "1880",
      "1881",
      "1882",
      "1883",
      "1884",
      "1885",
      "1886",
      "1887",
      "1888",
      "1889",
      "1890",
      "1891",
      "1892",
      "1893",
      "1894",
      "1895",
      "1896",
      "1897",
      "1898",
      "1899",
      "1900",
      "1901",
      "1902",
      "1903",
      "1904",
      "1905",
      "1906",
      "1907",
      "1908",
      "1909",
      "1910",
      "1911",
      "1912",
      "1913",
      "1914",
      "1915",
      "1916",
      "1917",
      "1918",
      "1919",
      "1920",
      "1921",
      "1922",
      "1923",
      "1924",
      "1925",
      "1926",
      "1927",
      "1928",
      "1929",
      "1930",
      "1931",
      "1932",
      "1933",
      "1934",
      "1935",
      "1936",
      "1937",
      "1938",
      "1939",
      "1940",
      "1941",
      "1942",
      "1943",
      "1944",
      "1945",
      "1946",
      "1947",
      "1948",
      "1949",
      "1950",
      "1951",
      "1952",
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026",
      "2027",
      "2028",
      "2029",
      "2030",
      "2031",
      "2032",
      "2033",
      "2034",
      "2035",
      "2036",
      "2037",
      "2038",
      "2039",
      "2040",
      "2041",
      "2042",
      "2043",
      "2044",
      "2045",
      "2046",
      "2047",
      "2048",
      "2049",
      "2050",
      "2051",
      "2052",
      "2053",
      "2054",
      "2055",
      "2056",
      "2057",
      "2058",
      "2059",
      "2060",
      "2061",
      "2062",
      "2063",
      "2064",
      "2065",
      "2066",
      "2067",
      "2068",
      "2069",
      "2070",
      "2071",
      "2072",
      "2073",
      "2074",
      "2075",
      "2076",
      "2077",
      "2078",
      "2079",
      "2080",
      "2081",
      "2082",
      "2083",
      "2084",
      "2085",
      "2086",
      "2087",
      "2088",
      "2089",
      "2090",
      "2091",
      "2092",
      "2093",
      "2094",
      "2095",
      "2096",
      "2097",
      "2098",
      "2099",
      "2100",
    ];

    for (var i = 0; i < unallowedYears.length; i++) {
      var isContain = str.indexOf(unallowedYears[i]) >= 0;
      if (isContain === true) {
        return true;
      }
    }

    return false;
  }

  // Custom security checks
  function isContainUnsecureRule(str) {
    var startWithWhiteSpace = str.startsWith(String.fromCharCode(160));
    var endWithWhiteSpace = str.endsWith(String.fromCharCode(160));
    var startWithSpace = str.startsWith(" ");
    var endWithSpace = str.endsWith(" ");

    if (
      startWithWhiteSpace ||
      endWithWhiteSpace ||
      startWithSpace ||
      endWithSpace
    ) {
      return true;
    }

    if (str.includes("'")) return true;

    if ((str.match(/(?:13579|1357|135)/g) || []).length > 0) {
      return true;
    }

    return false;
  }

  function IsHaveNumericSequence(str) {
    var numbers = getNumericCharArray(str);
    for (var i = 0; i < numbers.length; i++) {
      var isValid = IsSequence(numbers[i]);
      if (isValid === true) {
        return true;
      }
    }
    return false;
  }

  function getUpperCaseChars(str) {
    return str.match(/[A-Z]/g) || [];
  }

  function getLowerCaseChars(str) {
    return str.match(/[a-z]/g) || [];
  }

  function getRepeatedNumericChars(str) {
    return str.match(/(\d)\1/g) || [];
  }

  function GetAllRepatedAlphaNumerics(str) {
    return str.match(/([a-zA-Z0-9])\1/gi) || [];
  }

  function getNumericCharArray(str) {
    return str.match(/\d+/g) || [];
  }

  function getNumericCharCount(str) {
    return getNumericCharArray(str).join("").length;
  }

  function ValidateUserName(Username) {
    
    var self = CloudMailPassword;
    var multipleDots = /(\.)\1/g
    var specialCharacters = /(\W|_)/g
    var allowedCharacters = /[-_'.]/g

    if (Username.length > 64) {

        return {
            'Status': false,
            'Message': 'Password_Validation_Error_UserName_Max_Length',
            'Username': Username,
            'Information': self.Information,
            'Requirements': self.Requiremets
        }

        return false;
    }

    // Is user name contain repeated dot
    if (Username.match(multipleDots)) {

        return {
            'Status': false,
            'Message': 'Password_Validation_Error_UserName_Repeated_Dots',
            'Username': Username,
            'Information': self.Information,
            'Requirements': self.Requiremets
        }

        return false;
    }

    var startWithDot = Username.startsWith('.');
    var endWithDot = Username.endsWith('.');

    if (startWithDot || endWithDot) {

        return {
            'Status': false,
            'Message': 'Password_Validation_Error_UserName_StartEnd_With_Dots',
            'Username': Username,
            'Information': self.Information,
            'Requirements': self.Requiremets
        }

        return false;
    }

    // Is user name contain special characters
    if (Username.replace(allowedCharacters, 'ntr').match(specialCharacters)) {

        return {
            'Status': false,
            'Message': 'Password_Validation_Error_UserName_NonAlphaNumericsCharacters',
            'Username': Username,
            'Information': self.Information,
            'Requirements': self.Requiremets
        }

        return false;
    }

    return true;
}

  var sampleDataset = [];
  var mostCommonPasswords = [
    "123456",
    "123456789",
    "qwerty",
    "12345678",
    "111111",
    "1234567890",
    "1234567",
    "password",
    "123123",
    "987654321",
    "qwertyuiop",
    "mynoob",
    "123321",
    "666666",
    "18atcskd2w",
    "7777777",
    "1q2w3e4r",
    "654321",
    "555555",
    "3rjs1la7qe",
    "google",
    "1q2w3e4r5t",
    "123qwe",
    "zxcvbnm",
    "1q2w3e",
    "",
    "12345",
    "abc123",
    "football",
    "monkey",
    "letmein",
    "1234",
    "dragon",
    "baseball",
    "trustno1",
    "iloveyou",
    "princess",
    "adobe123",
    "welcome",
    "login",
    "admin",
    "solo",
    "master",
    "sunshine",
    "photoshop",
    "1qaz2wsx",
    "ashley",
    "mustang",
    "121212",
    "starwars",
    "bailey",
    "access",
    "flower",
    "passw0rd",
    "shadow",
    "michael",
    "jesus",
    "password1",
    "superman",
    "hello",
    "696969",
    "hottie",
    "freedom",
    "qazwsx",
    "ninja",
    "azerty",
    "loveme",
    "whatever",
    "batman",
    "zaq1zaq1",
    "Football",
    "000000",
    "aA11bB123",
  ];
};
